import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["abonar", "delete"]
  static values = {
    loanId: Number,
    modal: String,
  }

  connect() {
    console.log("Confirm controller connected")
  }

  async perform(event) {
  }

  showAbonarModal() {
    const modal = document.getElementById("abonar")
    modal.classList.remove("hidden")

  }

  cancel() {
    const modal = document.getElementById("abonar")
    modal.classList.add("hidden")
  }

  showDeleteModal() {
    const modal = document.getElementById("delete")
    modal.classList.remove("hidden")

  }

  cancelDelete() {
    const modal = document.getElementById("delete")
    modal.classList.add("hidden")
  }

  rollback(e) {
    const modal = document.getElementById("delete")
    modal.classList.add("hidden")

    const promise = new Promise((resolve) => {
      setTimeout(() => {
        const modalSuccess = document.getElementById("success")
        modalSuccess.classList.remove("hidden")
        resolve();
      }, 500);
    });

    promise.then(() => {
      setTimeout(() => {

        const modalSuccess = document.getElementById("success")
        modalSuccess.classList.add("hidden")
      }, 1500);
    });
  }
  
  apply() {
    const modal = document.getElementById("abonar")
    modal.classList.add("hidden")

    const promise = new Promise((resolve) => {
      setTimeout(() => {
        const modalSuccess = document.getElementById("success_apply")
        modalSuccess.classList.remove("hidden")
        resolve();
      }, 500);
    });

    promise.then(() => {
      setTimeout(() => {
        const modalSuccess = document.getElementById("success_apply")
        modalSuccess.classList.add("hidden")
      }, 1500);
    });
  }

  closeModal() {
   let dialog = document.getElementById("turbo-create-category");
    if (dialog) {
      dialog.close();
    } else {
      console.error("Dialog with id 'turbo-create-category' not found.");
    }
  }

  closeModalUpdate() {
   let dialog = document.getElementById("turbo-edit-category");
    if (dialog) {
      dialog.close();
    } else {
      console.error("Dialog with id 'turbo-create-category' not found.");
    }
  }

  closeModalUploadInvoices() {
   let dialog = document.getElementById("upload-invoices");
    if (dialog) {
      dialog.close();
    } else {
      console.error("Dialog with id 'turbo-create-category' not found.");
    }
  }

  closeModalCategoryProducts() {
   let dialog = document.getElementById("turbo-create-category-product");
    if (dialog) {
      dialog.close();
    } else {
      console.error("Dialog with id 'turbo-create-category' not found.");
    }
  }

  closeModalUpdateCategoryProducts() {
   let dialog = document.getElementById("turbo-edit-category-product");
    if (dialog) {
      dialog.close();
    } else {
      console.error("Dialog with id 'turbo-create-category' not found.");
    }
  }

  closeAddModal () {
    let dialog = document.getElementById(this.modalValue);

    if (dialog) {
      dialog.close();
    } else {
      console.error("Dialog with id 'turbo-create-category' not found.");
    }

  }
}
